import axios from './index';

export const getConversionRequest = (values) =>
  axios.get(
    `/v1/vendors/conversions/get/conversions/-/${values?.adID || '-'}/${values?.from || '-'}/${
      values?.to || '-'
    }/-/-`
  );
